import {getCustomViews, putCustomView, deleteCustomView} from '../helper'
import moment from 'moment'
const userPlotsStore = {
  state: {
    userPlots: []
  },
  getters: {
    userPlots(state) {
      return state.userPlots
    },
  },
  actions: {
    async refreshUserPlots (context) {
      let result = await getCustomViews()
      context.commit('setUserPlots', result.views.map(x=>{
        let a=x.json
        a.published=x.published
        a.user_id=x.user_id
        return a
      }))
    },
    async addUserPlot (context, plot) {
      plot.lastUpdated=moment().format('YYYY-MM-DD HH:mm:ss')
      await putCustomView({
        view_id:plot.id,
        published:plot.published ? plot.published : false,
        json:plot
      })
      context.dispatch('refreshUserPlots')
      context.dispatch('refreshPublishedCustomViews')
    },
    async publishUserPlot (context, plot) {
      await putCustomView({
        view_id:plot.id,
        published:true,
        json:plot
      })
      let newPlots=[...context.state.userPlots]
      for(let somePlot of newPlots){
        if(somePlot.id===plot.id){
          somePlot.published=true
        }
      }
      context.commit('setUserPlots', newPlots)
      context.dispatch('refreshPublishedCustomViews')
    },
    async unpublishUserPlot (context, plot) {
      await putCustomView({
        view_id:plot.id,
        published:false,
        json:plot
      })
      let newPlots=[...context.state.userPlots]
      for(let somePlot of newPlots){
        if(somePlot.id===plot.id){
          somePlot.published=false
        }
      }
      context.commit('setUserPlots', newPlots)
      context.dispatch('refreshPublishedCustomViews')
    },
    async deleteUserPlot (context, plot) {
      await deleteCustomView({
        view_id:plot.id,
      })
      let newPlots=[...context.state.userPlots].filter(x=>x.id!==plot.id)
      context.commit('setUserPlots', newPlots)
    },
  },

  mutations: {
    setUserPlots (state, userPlots) {
      state.userPlots = userPlots
    }
  }
}

export default userPlotsStore
